import { Client } from "../../../ducks/client";
import { PlusIcon } from "../../atoms/icons/PlusIcon";
import { MainTemplate } from "../../templates/MainTemplate";
import { TableTemplate } from "../../templates/TableTemplate";
import { useClients } from "./hook";

export const ClientsPage: React.FC = () => {
  const {
    clients,
    tableHeaders,
    fetchClients,
    handleRegistration,
    handleEdit,
  } = useClients();

  return (
    <MainTemplate
      title="顧客一覧"
      number={clients ? `（${clients.length}件）` : ""}
      useFitHeight
      button={{
        text: "新規顧客登録",
        variant: "filled",
        onClick: handleRegistration,
        icon: PlusIcon,
      }}
    >
      <TableTemplate<Client>
        headers={tableHeaders}
        data={clients ?? []}
        fetchDataFunction={fetchClients}
        editable
        onEdit={handleEdit}
        stickyHeader
        defaultEmptyText={clients ? "顧客情報がありません" : "データ取得中"}
      />
    </MainTemplate>
  );
};
